import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  defaults,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
defaults.font.family = "Montserrat";
export const options = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top" as const,
      display: false,
    },
    title: {
      display: false,
      text: "Chart.js Bar Chart",
    },
    datalabels: {
      font: {
        weight: 500,
      },
      formatter: (v: number) => `${v}%`,
    },
    tooltip: {
      callbacks: {
        label(context: any) {
          return ` ${context.raw}% of total`;
        }
      }
    }
  },
  scales: {
    y: {
      min: 0,
      max: 80,
      ticks: {
        display: false,
      },
      border: {
        display: false,
      },
    },
    x: {
      grid: {
        display: false,
      },
    },
  },
};

type Props = {
  male: number;
  female: number;
  loading: boolean;
  error: boolean;
  unconnected: boolean;
};

export default function GenderPresenter({ male, female, loading, error, unconnected }: Props) {
  return (
    <WidgetCard
      widgetId="AUDIENCE_GENDER"
      title="Audience Gender"
      loading={loading}
      error={error}
      unconnected={unconnected}
    >
      <Bar
        plugins={[ChartDataLabels]}
        options={options}
        data={{
          labels: ["MALE", "FEMALE"],
          datasets: [
            {
              data: [male, female],
              datalabels: {
                align: "start",
                anchor: "end",
                color: "#fff",
              },
              backgroundColor: ["#06B2DA", "#25BB9D"],
            },
          ],
        }}
      />
    </WidgetCard>
  );
}
